import {defaultKeywords} from "../keywords";

export const seoContentMapJa = {
    '/': {
        title: "Rodin - 画像から生成できる無料AI 3Dモデルジェネレーター | Hyper3D",
        description: "数秒でAIを使って魅力的な3Dモデルを作成。テキストや画像から簡単に生成して、今すぐクリエイティブプロセスを革新しましょう。",
        keywords: defaultKeywords,
        h1Text: "Rodin - テキストと画像対応の無料AI 3Dモデルジェネレーター",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin': {
        title: "Rodin - 無料で使えるAI 3Dモデルジェネレーター | Hyper3D",
        description: "数秒でAIを使って魅力的な3Dモデルを作成。テキストや画像をもとに簡単に3Dモデルを生成し、今すぐクリエイティブプロセスを変革しましょう！",
        keywords: defaultKeywords,
        h1Text: "Rodin - テキストと画像対応の無料AI 3Dモデルジェネレーター",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin/page': {
        title: "Rodin - AI 3Dモデルジェネレーター",
        description: "数秒でAIを使って魅力的な3Dモデルを作成。テキストや画像をもとに簡単に3Dモデルを生成し、今すぐクリエイティブプロセスを変革しましょう！",
        keywords: defaultKeywords,
        h1Text: "Rodin - テキストと画像対応の無料AI 3Dモデルジェネレーター",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
    },
    '/rodin/search': {
        title: "3Dモデル | Hyper3D",
        description: "fbx、obj、glb、usd形式の3Dモデルをすぐに閲覧して無料でダウンロード可能。ゲーム、VR/AR、映像制作、3Dプリントに最適です。",
        keywords: defaultKeywords,
        h1Text: "Rodin - テキストと画像対応の無料AI 3Dモデルジェネレーター",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
    },
    '/rodin/tab/story': {
        title: "Rodin - ユーザーストーリー集 | Hyper3D",
        description: "多彩なユーザーストーリーをチェックして、Rodinがアーティストやデザイナーの創作活動をどのように変革しているかご覧ください。",
        keywords: defaultKeywords,
        h1Text: "Rodin - テキストと画像対応の無料AI 3Dモデルジェネレーター",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/rodin/tab/story"
    },
    '/chatavatar': {
        title: "ChatAvatar - AIによる3Dフェイシャルアセット生成 | Hyper3D",
        description: "Hyper3DのChatAvatarは、テキストまたは画像から数分でPBRテクスチャ対応のハイパーリアルな3Dフェイシャルアセットを生成します。",
        keywords: defaultKeywords,
        h1Text: "ChatAvatar - 3Dフェイシャルアセットジェネレーター",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/imageto3d': {
        title: "ChatAvatar - AIによる3Dフェイシャルアセット生成 | Hyper3D",
        description: "Deemos Hyper3DのChatAvatarは、テキストや画像から数分でPBRテクスチャ対応のハイパーリアルな3Dフェイシャルアセットを生成します。",
        keywords: defaultKeywords,
        h1Text: "ChatAvatar - 3Dフェイシャルアセットジェネレーター",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/subscribe': {
        title: "料金プラン | Hyper3D",
        description: "Hyper3Dのサブスクリプションに登録して、限定機能やコンテンツを利用しましょう。",
        keywords: defaultKeywords + "Subscription, Hyper3D, Premium, Features",
        h1Text: "サブスクリプション - Hyper3D",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/subscribe"
    },
    '/api-dashboard': {
        title: "APIダッシュボード | Hyper3D",
        description: "Hyper3DのAPIキー管理と使用状況のモニタリングができます。",
        keywords: defaultKeywords + "API, Dashboard, Hyper3D, API Keys, Usage",
        h1Text: "APIダッシュボード",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/api-dashboard"
    },
    '/user/login': {
        title: "ログイン | Hyper3D",
        description: "Hyper3Dアカウントにアクセス。無料で利用可能。モデリングやテクスチャ作成など、Hyper3Dが多彩にサポートします。",
        keywords: defaultKeywords + "Login, Hyper3D, User, Account",
        h1Text: "ログイン",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/user/login"
    },
    '/signup': {
        title: "新規登録 | Hyper3D",
        description: "Hyper3Dの新規アカウントを作成。無料で利用可能。モデリングやテクスチャ作成など、Hyper3Dがクリエイティブをサポートします。",
        keywords: defaultKeywords + "Sign Up, Hyper3D, Register, Account",
        h1Text: "新規登録",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/signup"
    },
    '/legal/privacy': {
        title: "プライバシーポリシー | Hyper3D",
        description: "Hyper3Dのプライバシーポリシーをご覧いただき、データの取り扱いについてご確認ください。",
        keywords: defaultKeywords + "Privacy Policy, Hyper3D, Data Protection, Privacy",
        h1Text: "プライバシーポリシー",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/legal/privacy"
    },
    '/legal/terms': {
        title: "利用規約 | Hyper3D",
        description: "Hyper3Dの利用規約です。Hyper3Dサービスを利用してコンテンツを作成する際の条件についてご確認ください。",
        keywords: defaultKeywords + "Terms of Service, Hyper3D, Terms, Conditions",
        h1Text: "利用規約",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/legal/terms"
    },
    '/product/faq': {
        title: "よくある質問 | Hyper3D",
        description: "Hyper3Dの製品やサービスに関するよくある質問と回答をまとめています。",
        keywords: defaultKeywords + "FAQ, Hyper3D, Questions, Answers, Help",
        h1Text: "よくある質問",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/product/faq"
    },
    '/omnicraft': {
        title: "OmniCraft - 3Dツールボックス | Hyper3D",
        description: "Omnicraftは3Dアーティストやゲーム開発者、デザイナーなどを対象とした無料のオンライン3Dモデリングツールボックスです。",
        keywords: defaultKeywords + "HDRI Generator, image generator, image creator, omnicraft",
        h1Text: "イメージ、テキスト、想像力からあなたのバーチャル世界を創造しよう",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/omnicraft/"
    },
    '/omnicraft/hdri': {
        title: "HDRIパノラマジェネレーター - あなただけのバーチャル世界を構築 | Hyper3D",
        description: "画像やテキスト、あなたの発想から、数秒で独自のバーチャル世界を作り上げるHDRIパノラマジェネレーター。",
        keywords: defaultKeywords + "HDRI Generator, image generator, image creator, panorama generator, skybox generator",
        h1Text: "イメージ、テキスト、想像力からあなたのバーチャル世界を創造しよう",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/omnicraft/hdri"
    },
    '/omnicraft/formatcon': {
        title: "3Dフォーマットコンバーター - 無料・完全オフライン | Hyper3D",
        description: "3Dモデルファイルをドラッグ＆ドロップでobj、fbx、gltf、glb、usdなど多彩な形式に変換。無料で利用でき、完全オフライン対応。",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "無料・安全・完全オフラインの3Dモデルコンバーター",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/omnicraft/formatcon"
    },
    '/omnicraft/mesh': {
        title: "3Dメッシュスカルプト - 無料・完全オフライン | Hyper3D",
        description: "obj、fbx、3ds、dxf、glb、usdなど人気の高いフォーマットに対応した3Dメッシュスカルプトツール。無料で使えて、完全オフラインでも動作。",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "無料・安全・完全オフラインの3Dモデルコンバーター",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/omnicraft/mesh"
    },
    '/omnicraft/search': {
        title: "Rodin Search - 3Dモデル検索エンジン | Hyper3D",
        description: "Sketchfab、Daz3D、Rodinから3Dモデルを素早く検索。画像、テキスト、または3Dモデルそのものから検索可能な3D検索エンジンです。",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Rodin Search - 3Dモデル検索エンジン",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/omnicraft/search"
    },
    '/omnicraft/viewer': {
        title: "3Dモデルビューワー - 無料・完全オフライン | Hyper3D",
        description: "obj、fbx、stl、gltf、3ds、dxf、ply、glb、usdなど、あらゆる人気フォーマットに対応した3Dモデルビューワー。",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "無料・安全・完全オフラインの3Dモデルビューワー",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/omnicraft/viewer"
    },
    '/omnicraft/texture': {
        title: "3Dテクスチャジェネレーター - 画像から3Dテクスチャを生成 | Hyper3D",
        description: "AIテクスチャジェネレーターを使って、画像からリアルな3Dテクスチャを生成。モデルやゲーム、AR/VR、アート作品を生き生きと表現できます。",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "無料・安全・完全オフラインの3Dテクスチャジェネレーター",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Rodin & ChatAvatarで3Dモデリングを革新",
        canonicalUrl: "https://hyper3d.ai/omnicraft/texture"
    },
}